import { mapActions, mapGetters, mapState } from 'vuex';
import Draggable from 'vuedraggable';
import {
  GridColumn,
  GridForm,
  GridRow,
  GridTable,
} from '@/components/grid';
import ChromeEditor from '@/components/chrome/Editor.vue';
import ChromeEditorPanel from '@/components/chrome/EditorPanel.vue';
import FieldBase from '@/components/field/Base.vue';
import InfoBox from '@/components/InfoBox.vue';
import PillContent from '@/components/pill/PillContent.vue';
import SidebarPanel from '@/components/sidebar/SidebarPanel.vue';
import { IListItem } from './types';

export default (storeName: string) => ({
  data: () => ({
    fetched: false,
    rowShape: () => ({
      id: null,
      qty: null,
    } as IListItem),
  }),
  computed: {
    ...mapState('chromeEditor', ['panel']),
    ...mapState(storeName, ['batchList', 'products']),
    ...mapGetters(storeName, [
      'componentList',
      'materialList',
      'productList',
    ]),
    localValue: {
      get() {
        return this.batchList;
      },
      set(value: any) {
        this.updateBatchList(value);
      },
    },
    sidebarActions() {
      const basic = [
        {
          text: 'Print',
          onclick: () => print(),
        },
      ];

      return this.products.length
        ? [{
            onclick: () => this.addProduct(),
            text: 'Product',
          }, ...basic]
        : basic;
    },
  },
  methods: {
    ...mapActions(storeName, [
      'addToBatchList',
      'loadProducts',
      'updateBatchList',
    ]),
    addProduct() {
      this.addToBatchList();
      this.selectLastRowDropdown();
    },
    fetchData() {
      return this.loadProducts();
    },
    print() {
      window.print();
    },
    selectLastRowDropdown(timeout = 750) {
      setTimeout(() => {
        // a little long winded just incase timer is too fast for device processor
        const dropdownSelector = '[class*="Dropdown_dropdown_"]';
        const dropdown = this.$refs.productDropdown;
        dropdown && dropdown.$el.querySelector(dropdownSelector).click();
      }, timeout);
    },
    selectRowQty() {
      setTimeout(() => {
        // a little long winded just incase timer is too fast for device processor
        this.$refs.productQty.focus();
      }, 200);
    },
  },
  components: {
    ChromeEditor,
    ChromeEditorPanel,
    Draggable,
    FieldBase,
    GridColumn,
    GridForm,
    GridRow,
    GridTable,
    InfoBox,
    PillContent,
    SidebarPanel,
  },
} as IView);
